const prefix = <const T extends string>(id: T) => `Home.${id}` as const

export const HomeE2E = {
  Users: {
    /**
     * General user: Existing user with an issued card and onboarding checklist items.
     * Used to test the home screen for users who have completed card application.
     */
    General: {
      Email: 'ebc4ad6f-bd40-4ad9-ada4-e6b44b6c28e8@mailslurp.biz',
      FirstName: 'End To End Testing',
      LastName: 'Home General',
      PhoneNumber: '(892) 123-8912',
    },
    /**
     * New user: User who has not yet applied for a card.
     * Used to test the home screen card application call-to-action for new users.
     */
    NewUser: {
      Email: '2a99fea5-4ad7-4857-81fb-87e5d722ce0c@mailslurp.biz',
      FirstName: 'End To End Testing',
      LastName: 'Home New User',
      PhoneNumber: '(892) 123-8914',
    },
    /**
     * Platform user: User who has a Lithic/LoanPro card.
     * Used to test the home screen card application call-to-action for platform users.
     */
    Platform: {
      Email: '53bdd1cd-80f3-473e-88c7-d58f15606b48@mailslurp.biz',
      FirstName: 'End To End Testing',
      LastName: 'Home Platform',
      PhoneNumber: '(892) 123-8915',
    },
  },
  Ids: {
    View: {
      HomeIndex: prefix('View.HomeIndex'),
      Highnote: {
        HomeIndex: prefix('View.Highnote.HomeIndex'),
      },
      OnboardingChecklist: prefix('View.OnboardingChecklist'),
      CardSection: prefix('View.CardSection'),
    },
  },
} as const
